import type { DocMigration } from "../docMigration";

const GRADE_DATUM_ID = "qQWYrvGzkjRIAaIx";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_240: DocMigration = {
  maxSchemaVersion: "0.0.240",
  description: "Migrates 'Level X > grade' references to common grade",
  apply(json: any) {
    const gradeRefs: string[] = [];

    if (json.levels) {
      for (const levelId of Object.keys(json.levels)) {
        gradeRefs.push(levelId + "-grade");
      }
    } else {
      return json;
    }

    if (json.stairBlocks) {
      for (const stairBlockId of Object.keys(json.stairBlocks)) {
        const stairBlock = json.stairBlocks[stairBlockId];
        switch (stairBlock.type) {
          case "RUN": {
            if (stairBlock.hostingLower) {
              if (gradeRefs.indexOf(stairBlock.hostingLower.datum) > -1) {
                json.stairBlocks[stairBlockId].hostingLower.datum = GRADE_DATUM_ID;
              }
            }
            if (stairBlock.hostingLower) {
              if (gradeRefs.indexOf(stairBlock.hostingLower.datum) > -1) {
                json.stairBlocks[stairBlockId].hostingLower.datum = GRADE_DATUM_ID;
              }
            }
            break;
          }
          case "LANDING": {
            if (stairBlock.hosting) {
              if (gradeRefs.indexOf(stairBlock.hosting.datum) > -1) {
                json.stairBlocks[stairBlockId].hosting.datum = GRADE_DATUM_ID;
              }
            }
            break;
          }
        }
      }
    }

    if (json.columns) {
      for (const columnId of Object.keys(json.columns)) {
        const column = json.columns[columnId];
        if (column.verticalDatum?.bottomDatumId) {
          if (gradeRefs.indexOf(column.verticalDatum.bottomDatumId) > -1) {
            json.columns[columnId].verticalDatum.bottomDatumId = GRADE_DATUM_ID;
          }
        }
        if (column.verticalDatum?.topDatumId) {
          if (gradeRefs.indexOf(column.verticalDatum.topDatumId) > -1) {
            json.columns[columnId].verticalDatum.topDatumId = GRADE_DATUM_ID;
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_240;
